(function() { window.GUID_b93468f0_04f2_4f2e_81df_ff27dd698837 = { getGuid: function() { return "b93468f0-04f2-4f2e-81df-ff27dd698837"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class EventRowContainer extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off('click.' + this.UniqueNamespace, '.event-row .button');
                this.$control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.$Control.on('click.' + me.controlId, '.event-row .button', function (e) {
                    let $this = $(this);
                });
            }
        }
        Controls.EventRowContainer = EventRowContainer;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=event-row-container.js.map
